/* AUTOGENERATED from /home/philipp/Preisliste/prices.py — DO NOT EDIT */
/* Run: python3 /home/philipp/Preisliste/prices_to_js.py */
window.BAMINGER_PRICES = {
  "EU": {
    "currency": "EUR",
    "symbol": "€",
    "mwst_factor": 1.2,
    "transporter": {
      "tiers": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 144,
          "kunstleder_uvp": 166
        },
        {
          "tier": 2,
          "stoff_uvp": 247,
          "kunstleder_uvp": 314
        },
        {
          "tier": 3,
          "stoff_uvp": 276,
          "kunstleder_uvp": 353
        },
        {
          "tier": 4,
          "stoff_uvp": 362,
          "kunstleder_uvp": 458
        },
        {
          "tier": 5,
          "stoff_uvp": 449,
          "kunstleder_uvp": 554
        },
        {
          "tier": 6,
          "stoff_uvp": 526,
          "kunstleder_uvp": 660
        },
        {
          "tier": 7,
          "stoff_uvp": 583,
          "kunstleder_uvp": 746
        },
        {
          "tier": 8,
          "stoff_uvp": 698,
          "kunstleder_uvp": 881
        },
        {
          "tier": 9,
          "stoff_uvp": 785,
          "kunstleder_uvp": 958
        }
      ]
    },
    "lkw": {
      "tiers": [
        1,
        2,
        3,
        6,
        7
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 137,
          "kunstleder_uvp": 161
        },
        {
          "tier": 2,
          "stoff_uvp": 257,
          "kunstleder_uvp": 307
        },
        {
          "tier": 3,
          "stoff_uvp": 382,
          "kunstleder_uvp": 458
        },
        {
          "tier": 6,
          "stoff_uvp": 526,
          "kunstleder_uvp": 660
        },
        {
          "tier": 7,
          "stoff_uvp": 583,
          "kunstleder_uvp": 746
        }
      ]
    },
    "pickup": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 156,
          "kunstleder_uvp": 185
        },
        {
          "tier": 2,
          "stoff_uvp": 286,
          "kunstleder_uvp": 358
        },
        {
          "tier": 5,
          "stoff_uvp": 487,
          "kunstleder_uvp": 593
        }
      ]
    },
    "pkw": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 156,
          "kunstleder_uvp": 185
        },
        {
          "tier": 2,
          "stoff_uvp": 286,
          "kunstleder_uvp": 358
        },
        {
          "tier": 5,
          "stoff_uvp": 487,
          "kunstleder_uvp": 593
        }
      ]
    },
    "spezial": {
      "tiers": [
        [
          1,
          10
        ],
        [
          10,
          50
        ],
        [
          50,
          null
        ]
      ],
      "rows": [
        {
          "tier": [
            1,
            10
          ],
          "stoff_uvp": 167,
          "kunstleder_uvp": 190
        },
        {
          "tier": [
            10,
            50
          ],
          "stoff_uvp": 156,
          "kunstleder_uvp": 170
        },
        {
          "tier": [
            50,
            null
          ],
          "stoff_uvp": 148,
          "kunstleder_uvp": 161
        }
      ]
    },
    "fussmatten": {
      "tiers": [
        [
          1,
          4
        ],
        [
          5,
          19
        ],
        [
          20,
          49
        ],
        [
          50,
          99
        ],
        [
          100,
          249
        ],
        [
          250,
          999
        ],
        [
          1000,
          null
        ]
      ],
      "rows": [
        {
          "tier_label": "1-4 Stück",
          "tier_from": 1,
          "tier_to": 4,
          "gummi": {
            "uvp": 126
          },
          "teppich": {
            "uvp": 67
          },
          "velours": {
            "uvp": 115
          }
        },
        {
          "tier_label": "ab 5 Stück",
          "tier_from": 5,
          "tier_to": 19,
          "gummi": {
            "uvp": 108
          },
          "teppich": {
            "uvp": 56
          },
          "velours": {
            "uvp": 97
          }
        },
        {
          "tier_label": "ab 20 Stück",
          "tier_from": 20,
          "tier_to": 49,
          "gummi": {
            "uvp": 98
          },
          "teppich": {
            "uvp": 49
          },
          "velours": {
            "uvp": 83
          }
        },
        {
          "tier_label": "ab 50 Stück",
          "tier_from": 50,
          "tier_to": 99,
          "gummi": {
            "uvp": 91
          },
          "teppich": {
            "uvp": 44
          },
          "velours": {
            "uvp": 76
          }
        },
        {
          "tier_label": "ab 100 Stück",
          "tier_from": 100,
          "tier_to": 249,
          "gummi": {
            "uvp": 86
          },
          "teppich": {
            "uvp": 42
          },
          "velours": {
            "uvp": 71
          }
        },
        {
          "tier_label": "ab 250 Stück",
          "tier_from": 250,
          "tier_to": 999,
          "gummi": {
            "uvp": 83
          },
          "teppich": {
            "uvp": 40
          },
          "velours": {
            "uvp": 67
          }
        },
        {
          "tier_label": "ab 1.000 Stück",
          "tier_from": 1000,
          "tier_to": null,
          "gummi": {
            "uvp": 80
          },
          "teppich": {
            "uvp": 38
          },
          "velours": {
            "uvp": 65
          }
        }
      ]
    },
    "logo_sitz_per_seat_brutto": 12,
    "logo_sitz_min_count": 6,
    "logo_sitz_setup_fee_brutto": 58,
    "logo_fm_per_row_brutto": 18,
    "logo_fm_setup_fee_brutto": 58,
    "kunstleder_verstaerkung_per_seat_brutto": 19.2,
    "transport_sitz_per_paket": 15,
    "transport_fm_per_paket": 18,
    "b2b_staffel": [
      [
        10,
        0.05
      ],
      [
        40,
        0.12
      ]
    ]
  },
  "CH": {
    "currency": "CHF",
    "symbol": "CHF",
    "mwst_factor": 1.081,
    "transporter": {
      "tiers": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 171,
          "kunstleder_uvp": 197
        },
        {
          "tier": 2,
          "stoff_uvp": 292,
          "kunstleder_uvp": 370
        },
        {
          "tier": 3,
          "stoff_uvp": 326,
          "kunstleder_uvp": 422
        },
        {
          "tier": 4,
          "stoff_uvp": 430,
          "kunstleder_uvp": 543
        },
        {
          "tier": 5,
          "stoff_uvp": 534,
          "kunstleder_uvp": 655
        },
        {
          "tier": 6,
          "stoff_uvp": 620,
          "kunstleder_uvp": 776
        },
        {
          "tier": 7,
          "stoff_uvp": 690,
          "kunstleder_uvp": 880
        },
        {
          "tier": 8,
          "stoff_uvp": 828,
          "kunstleder_uvp": 1044
        },
        {
          "tier": 9,
          "stoff_uvp": 932,
          "kunstleder_uvp": 1131
        }
      ]
    },
    "lkw": {
      "tiers": [
        1,
        2,
        3,
        6,
        7
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 162,
          "kunstleder_uvp": 192
        },
        {
          "tier": 2,
          "stoff_uvp": 306,
          "kunstleder_uvp": 365
        },
        {
          "tier": 3,
          "stoff_uvp": 453,
          "kunstleder_uvp": 545
        },
        {
          "tier": 6,
          "stoff_uvp": 620,
          "kunstleder_uvp": 776
        },
        {
          "tier": 7,
          "stoff_uvp": 690,
          "kunstleder_uvp": 880
        }
      ]
    },
    "pickup": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 184,
          "kunstleder_uvp": 218
        },
        {
          "tier": 2,
          "stoff_uvp": 339,
          "kunstleder_uvp": 426
        },
        {
          "tier": 5,
          "stoff_uvp": 582,
          "kunstleder_uvp": 703
        }
      ]
    },
    "pkw": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 184,
          "kunstleder_uvp": 218
        },
        {
          "tier": 2,
          "stoff_uvp": 339,
          "kunstleder_uvp": 426
        },
        {
          "tier": 5,
          "stoff_uvp": 582,
          "kunstleder_uvp": 703
        }
      ]
    },
    "spezial": {
      "tiers": [
        [
          1,
          10
        ],
        [
          10,
          50
        ],
        [
          50,
          null
        ]
      ],
      "rows": [
        {
          "tier": [
            1,
            10
          ],
          "stoff_uvp": 197,
          "kunstleder_uvp": 225
        },
        {
          "tier": [
            10,
            50
          ],
          "stoff_uvp": 184,
          "kunstleder_uvp": 202
        },
        {
          "tier": [
            50,
            null
          ],
          "stoff_uvp": 175,
          "kunstleder_uvp": 192
        }
      ]
    },
    "fussmatten": {
      "tiers": [
        [
          1,
          4
        ],
        [
          5,
          19
        ],
        [
          20,
          49
        ],
        [
          50,
          99
        ],
        [
          100,
          249
        ],
        [
          250,
          999
        ],
        [
          1000,
          null
        ]
      ],
      "rows": [
        {
          "tier_label": "1-4 Stück",
          "tier_from": 1,
          "tier_to": 4,
          "gummi": {
            "uvp": 173
          },
          "teppich": {
            "uvp": 122
          },
          "velours": {
            "uvp": 208
          }
        },
        {
          "tier_label": "ab 5 Stück",
          "tier_from": 5,
          "tier_to": 19,
          "gummi": {
            "uvp": 148
          },
          "teppich": {
            "uvp": 103
          },
          "velours": {
            "uvp": 175
          }
        },
        {
          "tier_label": "ab 20 Stück",
          "tier_from": 20,
          "tier_to": 49,
          "gummi": {
            "uvp": 136
          },
          "teppich": {
            "uvp": 89
          },
          "velours": {
            "uvp": 151
          }
        },
        {
          "tier_label": "ab 50 Stück",
          "tier_from": 50,
          "tier_to": 99,
          "gummi": {
            "uvp": 124
          },
          "teppich": {
            "uvp": 80
          },
          "velours": {
            "uvp": 137
          }
        },
        {
          "tier_label": "ab 100 Stück",
          "tier_from": 100,
          "tier_to": 249,
          "gummi": {
            "uvp": 118
          },
          "teppich": {
            "uvp": 75
          },
          "velours": {
            "uvp": 128
          }
        },
        {
          "tier_label": "ab 250 Stück",
          "tier_from": 250,
          "tier_to": 999,
          "gummi": {
            "uvp": 114
          },
          "teppich": {
            "uvp": 72
          },
          "velours": {
            "uvp": 122
          }
        },
        {
          "tier_label": "ab 1.000 Stück",
          "tier_from": 1000,
          "tier_to": null,
          "gummi": {
            "uvp": 109
          },
          "teppich": {
            "uvp": 69
          },
          "velours": {
            "uvp": 118
          }
        }
      ]
    },
    "logo_sitz_per_seat_brutto": 14,
    "logo_sitz_min_count": 6,
    "logo_sitz_setup_fee_brutto": 69,
    "logo_fm_per_row_brutto": 21,
    "logo_fm_setup_fee_brutto": 69,
    "kunstleder_verstaerkung_per_seat_brutto": 22.48,
    "transport_sitz_per_paket": 35,
    "transport_fm_per_paket": 35,
    "b2b_staffel": [
      [
        10,
        0.05
      ],
      [
        40,
        0.12
      ]
    ],
    "endkunde_sitz": {
      "1": {
        "Transporter": {
          "Textil": {
            "1": 171,
            "2": 292,
            "3": 326,
            "4": 430,
            "5": 534,
            "6": 620,
            "7": 690,
            "8": 828,
            "9": 932
          },
          "Kunstleder": {
            "1": 197,
            "2": 370,
            "3": 422,
            "4": 543,
            "5": 655,
            "6": 776,
            "7": 880,
            "8": 1044,
            "9": 1131
          }
        },
        "LKW": {
          "Textil": {
            "1": 162,
            "2": 306,
            "3": 453,
            "6": 620,
            "7": 690
          },
          "Kunstleder": {
            "1": 192,
            "2": 365,
            "3": 545,
            "6": 776,
            "7": 880
          }
        },
        "PKW/Pickup": {
          "Textil": {
            "1": 184,
            "2": 339,
            "5": 582
          },
          "Kunstleder": {
            "1": 218,
            "2": 426,
            "5": 703
          }
        }
      },
      "1.15": {
        "Transporter": {
          "Textil": {
            "1": 197,
            "2": 335,
            "3": 375,
            "4": 495,
            "5": 614,
            "6": 715,
            "7": 793,
            "8": 953,
            "9": 1072
          },
          "Kunstleder": {
            "1": 227,
            "2": 426,
            "3": 486,
            "4": 625,
            "5": 755,
            "6": 893,
            "7": 1012,
            "8": 1202,
            "9": 1300
          }
        },
        "LKW": {
          "Textil": {
            "1": 187,
            "2": 352,
            "3": 521,
            "6": 715,
            "7": 793
          },
          "Kunstleder": {
            "1": 222,
            "2": 421,
            "3": 626,
            "6": 893,
            "7": 1012
          }
        },
        "PKW/Pickup": {
          "Textil": {
            "1": 211,
            "2": 389,
            "5": 668
          },
          "Kunstleder": {
            "1": 251,
            "2": 490,
            "5": 808
          }
        }
      },
      "1.35": {
        "Transporter": {
          "Textil": {
            "1": 231,
            "2": 395,
            "3": 441,
            "4": 582,
            "5": 721,
            "6": 839,
            "7": 932,
            "8": 1119,
            "9": 1259
          },
          "Kunstleder": {
            "1": 266,
            "2": 499,
            "3": 569,
            "4": 733,
            "5": 885,
            "6": 1049,
            "7": 1188,
            "8": 1410,
            "9": 1527
          }
        },
        "LKW": {
          "Textil": {
            "1": 219,
            "2": 413,
            "3": 612,
            "6": 839,
            "7": 932
          },
          "Kunstleder": {
            "1": 259,
            "2": 493,
            "3": 735,
            "6": 1049,
            "7": 1188
          }
        },
        "PKW/Pickup": {
          "Textil": {
            "1": 248,
            "2": 458,
            "5": 785
          },
          "Kunstleder": {
            "1": 294,
            "2": 574,
            "5": 948
          }
        }
      }
    }
  },
  "UK": {
    "currency": "GBP",
    "symbol": "£",
    "mwst_factor": 1.2,
    "transporter": {
      "tiers": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 182,
          "kunstleder_uvp": 209
        },
        {
          "tier": 2,
          "stoff_uvp": 311,
          "kunstleder_uvp": 394
        },
        {
          "tier": 3,
          "stoff_uvp": 348,
          "kunstleder_uvp": 448
        },
        {
          "tier": 4,
          "stoff_uvp": 457,
          "kunstleder_uvp": 576
        },
        {
          "tier": 5,
          "stoff_uvp": 566,
          "kunstleder_uvp": 695
        },
        {
          "tier": 6,
          "stoff_uvp": 659,
          "kunstleder_uvp": 823
        },
        {
          "tier": 7,
          "stoff_uvp": 732,
          "kunstleder_uvp": 935
        },
        {
          "tier": 8,
          "stoff_uvp": 880,
          "kunstleder_uvp": 1108
        },
        {
          "tier": 9,
          "stoff_uvp": 989,
          "kunstleder_uvp": 1200
        }
      ]
    },
    "lkw": {
      "tiers": [
        1,
        2,
        3,
        6,
        7
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 173,
          "kunstleder_uvp": 204
        },
        {
          "tier": 2,
          "stoff_uvp": 324,
          "kunstleder_uvp": 388
        },
        {
          "tier": 3,
          "stoff_uvp": 480,
          "kunstleder_uvp": 578
        },
        {
          "tier": 6,
          "stoff_uvp": 659,
          "kunstleder_uvp": 823
        },
        {
          "tier": 7,
          "stoff_uvp": 732,
          "kunstleder_uvp": 935
        }
      ]
    },
    "pickup": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 194,
          "kunstleder_uvp": 230
        },
        {
          "tier": 2,
          "stoff_uvp": 359,
          "kunstleder_uvp": 451
        },
        {
          "tier": 5,
          "stoff_uvp": 617,
          "kunstleder_uvp": 745
        }
      ]
    },
    "pkw": {
      "tiers": [
        1,
        2,
        5
      ],
      "rows": [
        {
          "tier": 1,
          "stoff_uvp": 194,
          "kunstleder_uvp": 230
        },
        {
          "tier": 2,
          "stoff_uvp": 359,
          "kunstleder_uvp": 451
        },
        {
          "tier": 5,
          "stoff_uvp": 617,
          "kunstleder_uvp": 745
        }
      ]
    },
    "spezial": {
      "tiers": [
        [
          1,
          10
        ],
        [
          10,
          50
        ],
        [
          50,
          null
        ]
      ],
      "rows": [
        {
          "tier": [
            1,
            10
          ],
          "stoff_uvp": 209,
          "kunstleder_uvp": 238
        },
        {
          "tier": [
            10,
            50
          ],
          "stoff_uvp": 194,
          "kunstleder_uvp": 215
        },
        {
          "tier": [
            50,
            null
          ],
          "stoff_uvp": 186,
          "kunstleder_uvp": 204
        }
      ]
    },
    "fussmatten": {
      "tiers": [
        [
          1,
          4
        ],
        [
          5,
          19
        ],
        [
          20,
          49
        ],
        [
          50,
          99
        ],
        [
          100,
          249
        ],
        [
          250,
          999
        ],
        [
          1000,
          null
        ]
      ],
      "rows": [
        {
          "tier_label": "1-4 Stück",
          "tier_from": 1,
          "tier_to": 4,
          "gummi": {
            "uvp": 184
          },
          "teppich": {
            "uvp": 130
          },
          "velours": {
            "uvp": 220
          }
        },
        {
          "tier_label": "ab 5 Stück",
          "tier_from": 5,
          "tier_to": 19,
          "gummi": {
            "uvp": 157
          },
          "teppich": {
            "uvp": 109
          },
          "velours": {
            "uvp": 186
          }
        },
        {
          "tier_label": "ab 20 Stück",
          "tier_from": 20,
          "tier_to": 49,
          "gummi": {
            "uvp": 145
          },
          "teppich": {
            "uvp": 94
          },
          "velours": {
            "uvp": 160
          }
        },
        {
          "tier_label": "ab 50 Stück",
          "tier_from": 50,
          "tier_to": 99,
          "gummi": {
            "uvp": 132
          },
          "teppich": {
            "uvp": 85
          },
          "velours": {
            "uvp": 145
          }
        },
        {
          "tier_label": "ab 100 Stück",
          "tier_from": 100,
          "tier_to": 249,
          "gummi": {
            "uvp": 125
          },
          "teppich": {
            "uvp": 80
          },
          "velours": {
            "uvp": 136
          }
        },
        {
          "tier_label": "ab 250 Stück",
          "tier_from": 250,
          "tier_to": 999,
          "gummi": {
            "uvp": 120
          },
          "teppich": {
            "uvp": 77
          },
          "velours": {
            "uvp": 131
          }
        },
        {
          "tier_label": "ab 1.000 Stück",
          "tier_from": 1000,
          "tier_to": null,
          "gummi": {
            "uvp": 116
          },
          "teppich": {
            "uvp": 74
          },
          "velours": {
            "uvp": 126
          }
        }
      ]
    },
    "logo_sitz_per_seat_brutto": 15,
    "logo_sitz_min_count": 6,
    "logo_sitz_setup_fee_brutto": 73,
    "logo_fm_per_row_brutto": 22,
    "logo_fm_setup_fee_brutto": 73,
    "kunstleder_verstaerkung_per_seat_brutto": 23.04,
    "transport_sitz_per_paket": 33,
    "transport_fm_per_paket": 33,
    "b2b_staffel": [
      [
        10,
        0.05
      ],
      [
        40,
        0.12
      ]
    ],
    "endkunde_sitz": {
      "1": {
        "Transporter": {
          "Textil": {
            "1": 182,
            "2": 311,
            "3": 348,
            "4": 457,
            "5": 566,
            "6": 659,
            "7": 732,
            "8": 880,
            "9": 989
          },
          "Kunstleder": {
            "1": 209,
            "2": 394,
            "3": 448,
            "4": 576,
            "5": 695,
            "6": 823,
            "7": 935,
            "8": 1108,
            "9": 1200
          }
        },
        "LKW": {
          "Textil": {
            "1": 173,
            "2": 324,
            "3": 480,
            "6": 659,
            "7": 732
          },
          "Kunstleder": {
            "1": 204,
            "2": 388,
            "3": 578,
            "6": 823,
            "7": 935
          }
        },
        "PKW/Pickup": {
          "Textil": {
            "1": 194,
            "2": 359,
            "5": 617
          },
          "Kunstleder": {
            "1": 230,
            "2": 451,
            "5": 745
          }
        }
      },
      "1.15": {
        "Transporter": {
          "Textil": {
            "1": 209,
            "2": 358,
            "3": 400,
            "4": 526,
            "5": 650,
            "6": 756,
            "7": 841,
            "8": 1012,
            "9": 1136
          },
          "Kunstleder": {
            "1": 240,
            "2": 454,
            "3": 515,
            "4": 662,
            "5": 799,
            "6": 947,
            "7": 1075,
            "8": 1274,
            "9": 1380
          }
        },
        "LKW": {
          "Textil": {
            "1": 198,
            "2": 372,
            "3": 553,
            "6": 756,
            "7": 841
          },
          "Kunstleder": {
            "1": 234,
            "2": 445,
            "3": 665,
            "6": 947,
            "7": 1075
          }
        },
        "PKW/Pickup": {
          "Textil": {
            "1": 223,
            "2": 413,
            "5": 708
          },
          "Kunstleder": {
            "1": 265,
            "2": 518,
            "5": 857
          }
        }
      },
      "1.35": {
        "Transporter": {
          "Textil": {
            "1": 246,
            "2": 420,
            "3": 468,
            "4": 617,
            "5": 764,
            "6": 889,
            "7": 986,
            "8": 1187,
            "9": 1334
          },
          "Kunstleder": {
            "1": 282,
            "2": 532,
            "3": 605,
            "4": 778,
            "5": 938,
            "6": 1111,
            "7": 1261,
            "8": 1495,
            "9": 1620
          }
        },
        "LKW": {
          "Textil": {
            "1": 234,
            "2": 438,
            "3": 649,
            "6": 889,
            "7": 986
          },
          "Kunstleder": {
            "1": 275,
            "2": 524,
            "3": 780,
            "6": 1111,
            "7": 1261
          }
        },
        "PKW/Pickup": {
          "Textil": {
            "1": 262,
            "2": 484,
            "5": 832
          },
          "Kunstleder": {
            "1": 311,
            "2": 608,
            "5": 1006
          }
        }
      }
    }
  },
  "_generated_at": "2026-10-23T05:01:35",
  "_source": "prices.py"
};
